import { render } from "./HeartShow.vue?vue&type=template&id=ef6dbc8a&scoped=true"
import script from "./HeartShow.vue?vue&type=script&lang=js"
export * from "./HeartShow.vue?vue&type=script&lang=js"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef6dbc8a"]])

export default __exports__